module.exports = __webpack_public_path__ + "static/media/simple.0dc963ec.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/simple.jpeg
// module id = 307
// module chunks = 0